module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/attendance-details/attendance-details-grid/attendance-details-grid.component.css
// module id = ./src/app/hrms/payroll/attendance-details/attendance-details-grid/attendance-details-grid.component.css
// module chunks = main